import React from "react";
import styles from "./TextArea.module.css";

const TextArea = ({ className = "", ...props }) => (
  <textarea className={`${styles.textArea} ${className}`} {...props} />
);

export default TextArea;
